// Original vocabulary. Role tags constrain where a noun may be used.
export default [
  {
    "id": "rhythm-stick",
    "role": "countable",
    "singular": "rhythm stick",
    "plural": "rhythm sticks",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "drumstick",
    "role": "countable",
    "singular": "drumstick",
    "plural": "drumsticks",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "bell",
    "role": "countable",
    "singular": "bell",
    "plural": "bells",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "music-card",
    "role": "countable",
    "singular": "music card",
    "plural": "music cards",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "shaker",
    "role": "countable",
    "singular": "shaker",
    "plural": "shakers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "tambourine",
    "role": "countable",
    "singular": "tambourine",
    "plural": "tambourines",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "triangle-instrument",
    "role": "countable",
    "singular": "triangle instrument",
    "plural": "triangle instruments",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "music-sticker",
    "role": "countable",
    "singular": "music sticker",
    "plural": "music stickers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "pick",
    "role": "countable",
    "singular": "pick",
    "plural": "picks",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-drum",
    "role": "countable",
    "singular": "toy drum",
    "plural": "toy drums",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "ribbon",
    "role": "measurable",
    "singular": "ribbon",
    "plural": "ribbons",
    "tags": [
      "length"
    ]
  },
  {
    "id": "cord",
    "role": "measurable",
    "singular": "cord",
    "plural": "cords",
    "tags": [
      "length"
    ]
  },
  {
    "id": "cable",
    "role": "measurable",
    "singular": "cable",
    "plural": "cables",
    "tags": [
      "length"
    ]
  },
  {
    "id": "strap",
    "role": "measurable",
    "singular": "strap",
    "plural": "straps",
    "tags": [
      "length"
    ]
  },
  {
    "id": "case",
    "role": "container",
    "singular": "case",
    "plural": "cases",
    "tags": []
  },
  {
    "id": "box",
    "role": "container",
    "singular": "box",
    "plural": "boxes",
    "tags": []
  },
  {
    "id": "bag",
    "role": "container",
    "singular": "bag",
    "plural": "bags",
    "tags": []
  },
  {
    "id": "basket",
    "role": "container",
    "singular": "basket",
    "plural": "baskets",
    "tags": []
  },
  {
    "id": "musician",
    "role": "person",
    "singular": "musician",
    "plural": "musicians",
    "tags": []
  },
  {
    "id": "singer",
    "role": "person",
    "singular": "singer",
    "plural": "singers",
    "tags": []
  },
  {
    "id": "teacher",
    "role": "person",
    "singular": "teacher",
    "plural": "teachers",
    "tags": []
  },
  {
    "id": "listener",
    "role": "person",
    "singular": "listener",
    "plural": "listeners",
    "tags": []
  },
  {
    "id": "rehearsal",
    "role": "action",
    "singular": "rehearsal",
    "plural": "rehearsals",
    "tags": []
  },
  {
    "id": "concert",
    "role": "action",
    "singular": "concert",
    "plural": "concerts",
    "tags": []
  },
  {
    "id": "music-lesson",
    "role": "action",
    "singular": "music lesson",
    "plural": "music lessons",
    "tags": []
  },
  {
    "id": "practice-session",
    "role": "action",
    "singular": "practice session",
    "plural": "practice sessions",
    "tags": []
  },
  {
    "id": "stage",
    "role": "structure",
    "singular": "stage",
    "plural": "stages",
    "tags": []
  },
  {
    "id": "bandstand",
    "role": "structure",
    "singular": "bandstand",
    "plural": "bandstands",
    "tags": []
  },
  {
    "id": "music-room",
    "role": "place",
    "singular": "music room",
    "plural": "music rooms",
    "tags": []
  },
  {
    "id": "concert-hall",
    "role": "place",
    "singular": "concert hall",
    "plural": "concert halls",
    "tags": []
  }
];
